/*jshint esversion: 6 */
var chktoast = true;
$(document).ready(function () {
  $("#route").removeAttr("placeholder");
  $("#user_role").on("change", function () {
    var new_role = $(this).find(":selected").text();
    var old_role = $("#role_id").val();
    if (old_role != "") {
      if ($("#change_role").val() == "1") {
        var user_role = $("#user_role option[value='" + old_role + "']").text();
        if ($("#subscription_type").val() == "account-level") {
          if (
            (user_role == "User" || user_role == "Administrator") &&
            (new_role == "Data Entry / Non-Eval Access" ||
              new_role == "Super Administrator" ||
              new_role == "Developer" ||
              new_role == "None")
          ) {
            if (new_role == "Data Entry / Non-Eval Access") {
              $(".change_role_msg").html(
                "The downgrade will result in the user no longer having access to Evaluations. All existing evaluations that they have saved may be deleted from the application. Do you want to continue to make this change?"
              );
              $("#modal-change-user-type-alert").modal({ dismissible: false });
              $("#modal-change-user-type-alert").modal("open");
            }
            $("#update_subscription").val("1");
          } else if (
            (new_role == "User" || new_role == "Administrator") &&
            (user_role == "Data Entry / Non-Eval Access" ||
              user_role == "Super Administrator" ||
              user_role == "Developer" ||
              user_role == "None")
          ) {
            $(".change_role_msg").html(
              "An upgrade will result in the account being charged through the end of the current billing cycle"
            );
            if ($("#check_date").val() == "1") {
              $("#modal-change-user-type-alert").modal({ dismissible: false });
              $("#modal-change-user-type-alert").modal("open");
            }
            $("#update_subscription").val("1");
          } else {
            $("#update_subscription").val("0");
          }
        } else {
          if (
            (user_role == "User" || user_role == "Administrator") &&
            (new_role == "Data Entry / Non-Eval Access" ||
              new_role == "Super Administrator" ||
              new_role == "None")
          ) {
            if ($("#sub_status").val() == 1) {
              Materialize.toast(
                "Firstly you have to unsubscribe the Subscription after that you can change the role.",
                3000
              );
              $("#user_role").val(old_role);
              var $select_role = $("select.role");
              $select_role.material_select();
            }
          }
        }
      } else {
        $("#user_role").val(old_role);
        var $select1 = $("select.role");
        $select1.material_select();
        Materialize.toast(
          "You can't change the role because this is the last Admin role of this account.",
          3000
        );
      }
    }
  });
  if ($(".select_comp_type").length > 0) {
    var check_val = $(".select_comp_type:checked").val();
    if (check_val == "land_only") {
      $(".hide-if-land-only").addClass("hide");
    } else {
      $(".hide-if-land-only").removeClass("hide");
    }
    check_cap_comp_display();
  }

  $(".type_own_custom").each(function () {
    if ($(this).val() != "") {
      $(this).parent().parent().removeClass("enable-type-own");
    }
  });

  $("#enable_residential_mode").on("change", function () {
    var enable_residential_mode = "";
    if ($(this).is(":checked")) {
      enable_residential_mode = "Y";
    } else {
      enable_residential_mode = "N";
    }
    $.ajax({
      type: "POST",
      url: $("body").data("base-url") + "users/enable_residential_mode",
      data: {
        residential_mode: enable_residential_mode,
      },
      beforeSend: function () {
        startLoading("header");
      },
    }).done(function (data) {
      location.reload();
    });
  });

  $(".modal").modal();

  $(".tooltipped").tooltip({ delay: 50 });

  $(".scrollspy").scrollSpy();

  $(".phone").mask("(999) 999-9999");

  $("select[required]").css({
    display: "block",
    height: 0,
    padding: 0,
    width: 0,
    position: "absolute",
  });

  // Collapsible Menu
  $(".button-collapse-menu").sideNav();

  /**
   * Configuration for index tables.
   */
  if ($("#table").length) {
    $("#table").DataTable({
      searching: false,
      buttonClasses: "btn",
      lengthChange: false,
      drawCallback: function () {
        $(".tooltipped").tooltip({ delay: 50 });
      },
    });
  }

  var datepickers = $(".standalone-datepicker");

  $.each(datepickers, function (key, value) {
    var settings = {
      opens: "right",
      drops: "down",
      singleDatePicker: true,
      showDropdowns: true,
      autoUpdateInput: false,
      autoApply: true,
      locale: {
        format: "M/D/YYYY",
      },
    };

    if ($(value).data("datepicker-max") === "today") {
      settings.maxDate = Utils.getToday();
    }
    if ($(value).data("datepicker-min") === "today") {
      settings.minDate = Utils.getToday();
    }

    $(value).daterangepicker(settings);

    $(value).on("cancel.daterangepicker", function (ev, picker) {
      $(this).val("");
      $(this).parent().find("label").removeClass("active");
    });
    $(value).on("apply.daterangepicker", function (ev, picker) {
      $(this).val(picker.startDate.format(picker.locale.format));
      $(this).parent().find("label").addClass("active");
      // if ((location.pathname.indexOf('/comps') !== -1) || (location.pathname.indexOf('/master-properties') !== -1) || (location.pathname.indexOf('/evaluations/sales') !== -1) || (location.pathname.indexOf('/evaluations/cost') !== -1)) {
      if ($(this).hasClass("calcDaysOnMarket")) {
        get_days_on_market();
      }
      if (location.pathname.indexOf("evaluations/") !== -1) {
        currentval = $(this).val();
        if (previousval !== currentval) {
          dataToSave = true;
        }
      }
    });
  });

  var filterdatepickers = $(".filter-datepicker");

  $.each(filterdatepickers, function (key, value) {
    var filtersettings = {
      opens: "right",
      drops: "down",
      singleDatePicker: true,
      showDropdowns: true,
      // autoUpdateInput: false,
      autoApply: true,
      locale: {
        format: "M/D/YYYY",
      },
    };

    $(value).daterangepicker(filtersettings);
    $(value).on("cancel.daterangepicker", function (ev, picker) {
      $(this).val("");
      $(this).parent().find("label").removeClass("active");
    });
    $(value).on("apply.daterangepicker", function (ev, picker) {
      $(this).val(picker.startDate.format(picker.locale.format));
      $(this).parent().find("label").addClass("active");
    });
  });

  $(".filter-datepicker, .standalone-datepicker").on("keypress", function (e) {
    if (!(e.keyCode >= 47 && e.keyCode <= 57)) return false;
  });
  flag = false;
  $(".filter-datepicker, .standalone-datepicker").on("keyup", function (event) {
    if (event.keyCode == 8) {
      flag = true;
    } else {
      flag = false;
    }
  });
  $(".filter-datepicker, .standalone-datepicker").on("blur", function (event) {
    if (flag) {
      $(this).val("");
      $(this).parent().find("label").removeClass("active");
      flag = false;
      return false;
    }
    var date = $(this).val();
    if (date !== "") {
      var matches = /^(\d{1,2})[-\/](\d{1,2})[-\/](\d{4})$/.exec(date);
      if (matches == null) {
        $(this).parent().find("label").removeClass("active");
        Materialize.toast("Please enter a valid date", 2000);
        return $(this).val("");
      }
      var m = matches[1];
      var d = matches[2];
      var y = matches[3];
      var composedDate = new Date(m + "/" + d + "/" + y);
      if (composedDate == "Invalid Date" || y > 2100 || y < 1900) {
        // accept only recent & not too far years
        $(this).parent().find("label").removeClass("active");
        Materialize.toast("Please enter valid date", 2000);
        return $(this).val("");
      } else {
        return (
          composedDate.getDate() == d &&
          composedDate.getMonth() == m &&
          composedDate.getFullYear() == y
        );
      }
    } else {
      $(this).parent().find("label").removeClass("active");
      return $(this).val("");
    }
  });

  //Users table
  if ($("#users-table").length) {
    TableController.Users.init();
  }

  //Accounts table
  if ($("#accounts-table").length) {
    TableController.Accounts.init();
  }

  //Clients table
  if ($("#clients-table").length) {
    TableController.Clients.init();
  }

  //Initializing Properties Table
  if (location.pathname.indexOf("/properties") !== -1) {
    TableController.Properties.init();
  }
  $("#modal_first_login").modal({ dismissible: false, preventScrolling: true });
  if ($("#check_first_login").length) {
    if ($("#check_first_login").val() == "0") {
      $("#modal_first_login").modal("open");
    }
  }

  //Initializing Properties Table
  if (location.pathname.indexOf("/settings") !== -1) {
    TableController.Settings.init();
  }

  TableController.init();

  /**
   * Initializing materialize select.
   */
  if ($("select:not(.mat-off)").length) {
    $("select:not(.mat-off)").material_select();
  }

  if ($(".select2").length) {
    $(".select2").select2();
  }
  setTimeout(function () {
    $("#account_name").attr("autocomplete", "account-name-off");
  }, 1000);
  /**
   * Initialize materialize date picker.
   */
  var datePickerConfigs = {
    range: true,
    closeOnSelect: true,
    closeOnClear: true,
    selectMonths: true, // Creates a dropdown to control month
    selectYears: 15, // Creates a dropdown of 15 years to control year,
    today: "Today",
    clear: "Clear",
    close: "Ok",
    format: "mm/dd/yyyy",
    onRender: function () {
      // $('.picker__date-display').remove();
    },
    onClose: function () {
      $(document.activeElement).blur();
    },
  };

  $(".datepicker").pickadate(datePickerConfigs);

  $(document).on("click", ".delete", function () {
    $(this).parent(".entry").remove();
  });

  $(document).on("click", ".add", function () {
    if ($(".entry").length < 10) {
      var clone = $(".entry:last-of-type").clone();
      clone.find(":input").val("");
      clone.find(".delete").removeClass("hide");
      $(".entry:last-of-type").after(clone);
    }

    // Reinitialize the materialize select boxes
    if ($("select").length) {
      $("select").material_select();
    }
  });

  initializeAutoCompleteWithId();
  initializeMasks();
  if (!$("body").hasClass("mls") && !$("div").hasClass("select-comp")) {
    initInviteModals();
  }
});

function change_custom_field(obj, addclass, id, type = null) {
  if ($(obj).find("option:selected").text() == "Type My Own") {
    $("." + addclass).removeClass("enable-type-own");
    // if($(obj).attr('id')==="utilities_select")
    // {
    //     $('.utilities_type_field').removeClass('s3');
    //     $('.utilities_type_field').addClass('s6');
    // }
    if (type == "land") {
      $(".land_type_field").removeClass("s6");
      $(".land_type_field").removeClass("s4");
      $(".land_type_field").addClass("s3");
      $(".select_land_type").removeClass("s4");
      $(".select_land_type").addClass("s6");
      $("#" + id).attr("required", true);
    }
    if (type == "zone") $("#" + id).attr("required", true);
  } else {
    $("#" + id).val("");
    $("." + addclass).addClass("enable-type-own");
    // if($(obj).attr('id')==="utilities_select")
    // {
    //     $('.utilities_type_field').removeClass('s6');
    //     $('.utilities_type_field').addClass('s3');
    // }
    if (type == "land") {
      $(".land_type_field").removeClass("s3");
      $(".land_type_field").removeClass("s6");
      $(".land_type_field").addClass("s4");
      $(".select_land_type").removeClass("s6");
      $(".select_land_type").addClass("s4");
      $("#" + id).attr("required", false);
    }
    if (type == "zone") $("#" + id).attr("required", false);
  }
  if (type == "zone") {
    var change = false;
    $(".property_sub_type").each(function () {
      if ($(this).find("option:selected").text() == "Type My Own") {
        change = true;
      }
    });
    if (type == "zone") {
      if (location.pathname.indexOf("/properties/overview") !== -1) {
        if (change) {
          $(".property_width").removeClass("s5");
          $(".property_width").addClass("s4");
          $(".subzone_width").removeClass("s5");
          $(".subzone_width").addClass("s6");
        } else {
          $(".property_width").removeClass("s4");
          $(".property_width").addClass("s5");
          $(".subzone_width").removeClass("s6");
          $(".subzone_width").addClass("s5");
        }
      }
      // else{
      // if(change)
      // {
      // $('.property_width').removeClass('s4');
      // $('.property_width').addClass('s3');
      // $('.subzone_width').removeClass('s4');
      // $('.subzone_width').addClass('s5');
      // }else{
      // $('.property_width').removeClass('s3');
      // $('.property_width').addClass('s4');
      // $('.subzone_width').removeClass('s5');
      // $('.subzone_width').addClass('s4');
      // }
      // }
    }
  }
}
function initInviteModals() {
  // if (storage.get('hasSeenInvitationModal') !== 1) {
  //     $.get($('body').attr('data-base-url') + "users/showInvitationModal", function (data) {
  //         try {
  //             var responseTxt = JSON.parse(data);

  //             if (responseTxt.showModal) {
  //                 var modal = $('#invite-users-modal');

  //                 modal.modal();

  //                 modal.find('#account-id').val(responseTxt.id);

  //                 modal.modal('open');

  //                 $('.manager-invite-brokers-chips').material_chip({
  //                     placeholder: 'Enter an email address and press enter'
  //                 });
  //             }
  //             storage.set('hasSeenInvitationModal', 1);
  //         } catch (e) {
  //         }
  //     });
  // }

  if (storage.get("hasSeenManagerDefinitionModal") !== 1) {
    $.get(
      $("body").attr("data-base-url") + "users/showManagerDefinitionModal",
      function (data) {
        try {
          var responseTxt = JSON.parse(data);

          if (responseTxt.showModal) {
            var modal = $("#account-manager-modal");

            modal.modal();

            modal.find("#account-id").val(responseTxt.id);

            modal.modal("open");
          }

          storage.set("hasSeenManagerDefinitionModal", 1);
        } catch (e) {}
      }
    );
  }

  $(".set-user-as-account-manager").click(function () {
    $.post(
      $("body").attr("data-base-url") + "users/setAdministrator",
      function (data) {
        var response = JSON.parse(data);
        if (response.message) {
          Materialize.toast(response.message, 2000);
        }
      }
    );
  });

  $(".send-invitation-to-manager").click(function () {
    var data = {
      email: $("#account-manager-modal").find('[type="email"]').val(),
    };

    $.post(
      $("body").attr("data-base-url") + "users/setInvitationToAdministrator",
      data,
      function (data) {
        var response = JSON.parse(data);
        if (response.message) {
          Materialize.toast(response.message, 2000);
        }
      }
    );
  });

  $(".manager-invites-users").click(function (e) {
    var keyDownEvent = jQuery.Event("keydown");

    keyDownEvent.which = 13;
    keyDownEvent.keyCode = 13;

    $(".manager-invite-brokers-chips").find("input").trigger(keyDownEvent);

    // $('#invite-users-modal').modal('close');

    // $.post($('body').attr('data-base-url') + "users/sendInvite", {
    //     id: $('#invite-users-modal').find('#account-id').val(),
    //     'emails': JSON.stringify($('.manager-invite-brokers-chips').material_chip('data'))
    // }, function (data) {
    //     var response = JSON.parse(data);
    //     if (response.message) {
    //         Materialize.toast(response.message, 2000);
    //     }
    // });
  });
}

jQuery(window).on("load", function () {
  checkLoginForm();
  initializePropertyType();
});

function get_number(n) {
  if (typeof n === "string") {
    if (n.length > 0) {
      return parseFloat(n);
    } else {
      return 0;
    }
  } else if (typeof n === "number") {
    return n;
  } else if (n === null || n === undefined) {
    return 0;
  } else {
    return 0;
  }
}

function checkLoginForm() {
  /*  if (Utils.contains(location.pathname, 'login') || Utils.contains(location.pathname, 'signup')) {
          if($('input[name="email_address"]').is(":-webkit-autofill")) {
              $('input[name="email_address"]').parent().find('label').addClass('active');
          }
  
          if($('input[name="password"]').is(":-webkit-autofill")) {
              $('input[name="password"]').parent().find('label').addClass('active');
          }
      }*/

  if (Utils.contains(location.pathname, "signup")) {
    // $('.cant-find-company-link').click(function () {
    //     var $this = $(this);
    //     $this.addClass('hide');
    //     setTimeout(function(){
    //         $('#street_address').attr('autocomplete','street-address-off');
    //     }, 1000);
    //     google.maps.event.clearInstanceListeners($('#account_name')[0]);
    //     $('#account_name').parent().find('label').html('Full Company Name');
    //     $('#street_address').val('').parent().removeClass('hide');
    //     $('#account_name').val('');
    //     $('#city').val('');
    //     $('#state').val('');
    //     $('#zipcode').val('');
    //     $('#g_place_id').val('');
    //     var autocomplete = new google.maps.places.Autocomplete(
    //         (document.getElementById('street_address')), {
    //             types: ['establishment']
    //         });
    //     autocomplete.addListener('place_changed', function () {
    //         $('#account_name').val('');
    //         $('#city').val('');
    //         $('#state').val('');
    //         $('#zipcode').val('');
    //         $('#g_place_id').val('');
    //         var place = autocomplete.getPlace();
    //         var place_name = place.name;
    //         var zipcode = '';
    //         var city = '';
    //         var state = '';
    //         var place_id = place.place_id;
    //         $(place.address_components).each(function (i, el) {
    //             if ($.inArray('postal_code', el.types) !== -1) {
    //                 zipcode = el.long_name;
    //             }else if($.inArray('premise', el.types) !== -1){
    //                 zipcode = el.long_name;
    //             }
    //             if ($.inArray('locality', el.types) !== -1 && $.inArray('political', el.types) !== -1) {
    //                 city = el.long_name;
    //             }else if($.inArray('administrative_area_level_2', el.types) !== -1 && $.inArray('political', el.types) !== -1){
    //                 city = el.long_name;
    //             }
    //             if ($.inArray('administrative_area_level_1', el.types) !== -1 && $.inArray('political', el.types) !== -1) {
    //                 state = el.short_name.toLowerCase();
    //             }
    //         });
    //         $('#account_name').val(place_name);
    //         $('#city').val(city);
    //         $('select[name="state"]').val(state);
    //         $('select[name="state"]').material_select();
    //         $('#zipcode').val(zipcode);
    //         $('#g_place_id').val(place_id);
    //         $('#street_address').attr('value', place.formatted_address);
    //     });
    // });
  }
}

function initializeAutoCompleteWithId() {
  $.fn.autocomplete2 = function (options) {
    var defaults = {
      data: [],
    };

    options = $.extend(defaults, options);

    return this.each(function () {
      var $input = $(this);
      var data = options.data,
        $inputDiv = $input.closest(".input-field"); // Div to append on

      // Check if data isn't empty
      if (!$.isEmptyObject(data)) {
        // Create autocomplete element
        var $autocomplete = $(
          '<ul class="autocomplete-content dropdown-content"></ul>'
        );

        // Append autocomplete element
        if ($inputDiv.length) {
          $inputDiv.append($autocomplete); // Set ul in body
        } else {
          $input.after($autocomplete);
        }

        var highlight = function (string, $el) {
          var img = $el.find("img");
          var matchStart = $el
              .text()
              .toLowerCase()
              .indexOf("" + string.toLowerCase() + ""),
            matchEnd = matchStart + string.length - 1,
            beforeMatch = $el.text().slice(0, matchStart),
            matchText = $el.text().slice(matchStart, matchEnd + 1),
            afterMatch = $el.text().slice(matchEnd + 1);
          $el.html(
            "<span>" +
              beforeMatch +
              "<span class='highlight'>" +
              matchText +
              "</span>" +
              afterMatch +
              "</span>"
          );
          if (img.length) {
            $el.prepend(img);
          }
        };

        // Perform search
        $input.on("keyup", function (e) {
          // Capture Enter
          if (e.which === 13) {
            $autocomplete.find("li").first().click();
            return;
          }

          var val = $input.val().toLowerCase();
          $autocomplete.empty();

          // Check if the input isn't empty
          if (val !== "") {
            data.forEach(function (key, index) {
              if (
                key.hasOwnProperty("text") &&
                key.text.toLowerCase().indexOf(val) !== -1 &&
                key.text.toLowerCase() !== val
              ) {
                var autocompleteOption = $("<li data-id=" + key.id + "></li>");
                if (!!key.img) {
                  autocompleteOption.append(
                    '<img src="' +
                      key.img +
                      '" class="right circle"><span>' +
                      key.text +
                      "</span>"
                  );
                } else {
                  autocompleteOption.append("<span>" + key.text + "</span>");
                }
                $autocomplete.append(autocompleteOption);

                highlight(val, autocompleteOption);
              }
            });
          }
        });

        // Set input value
        $autocomplete.on("click", "li", function () {
          $input.val($(this).text().trim());
          $input.data("id", $(this).data("id"));
          $input.trigger("change");

          if (options.onAutocomplete) {
            options.onAutocomplete($input.data("id"));
          }

          $autocomplete.empty();
        });
      }
    });
  };
}

function initAutoCompleteWithAjaxAndId(options) {
  var defaults = {
    inputId: null,
    ajaxUrl: false,
    onSelect: false,
    data: {},
  };

  options = $.extend(defaults, options);

  var $input = $("#" + options.inputId);

  if (options.ajaxUrl !== false) {
    var $autocomplete = $(
        '<ul id="myId" class="autocomplete-content dropdown-content"></ul>'
      ),
      $inputDiv = $input.closest(".input-field"),
      //timeout,
      runningRequest = false,
      request;

    if ($inputDiv.length) {
      $inputDiv.append($autocomplete); // Set ul in body
    } else {
      $input.after($autocomplete);
    }

    var highlight = function (string, $el) {
      var img = $el.find("img");
      var matchStart = $el
          .text()
          .toLowerCase()
          .indexOf("" + string.toLowerCase() + ""),
        matchEnd = matchStart + string.length - 1,
        beforeMatch = $el.text().slice(0, matchStart),
        matchText = $el.text().slice(matchStart, matchEnd + 1),
        afterMatch = $el.text().slice(matchEnd + 1);
      //add code for business search
      if (matchStart === -1) {
        $el.html("<span>" + $el.text() + "</span>");
      } else {
        $el.html(
          "<span>" +
            beforeMatch +
            "<span class='highlight'>" +
            matchText +
            "</span>" +
            afterMatch +
            "</span>"
        );
      }
      if (img.length) {
        $el.prepend(img);
      }
    };

    $autocomplete.on("click", "li", function () {
      $input.val($(this).text().trim());
      $input.data("id", $(this).data("id"));
      $input.trigger("change");

      if (options.onAutocomplete) {
        options.onAutocomplete($input.data("id"));
      }

      $autocomplete.empty();

      if (typeof options.onSelect === "function") {
        options.onSelect($(this).data("id"));
      }
    });

    $input.on("keyup", function (e) {
      //if(timeout){ clearTimeout(timeout);}
      if (runningRequest) request.abort();

      if (e.which === 13) {
        $autocomplete.find("li").first().click();
        return;
      }

      var val = $input.val().toLowerCase();

      $autocomplete.empty();

      runningRequest = true;

      var ajaxData = { needle: val };

      if (options.limit) {
        ajaxData.limit = options.limit;
      }

      request = $.ajax({
        type: "GET", // your request type
        url: $("body").data("base-url") + options.ajaxUrl,
        data: ajaxData,
        success: function (response) {
          var comps = JSON.parse(response);
          if (comps.length > 0) {
            for (var key in comps) {
              if (comps.hasOwnProperty(key)) {
                var autocompleteOption = $(
                  "<li data-id=" + comps[key].id + "></li>"
                );

                var name = "";

                if (comps[key].street_address) {
                  var nameArray = [];
                  nameArray.push(comps[key].street_address);

                  if (comps[key].city) {
                    nameArray.push(comps[key].city);
                  }

                  if (comps[key].state) {
                    nameArray.push(comps[key].state.toUpperCase());
                  }

                  name = nameArray.join(", ");
                } else {
                  name = comps[key].business_name;
                }

                if (comps[key].property_image_url) {
                  if (comps[key].date_sold) {
                    autocompleteOption.append(
                      '<img src="' +
                        $("body").data("cdn-url") +
                        comps[key].property_image_url +
                        '" class="right circle"><span>' +
                        name +
                        " (Sold: " +
                        comps[key].date_sold +
                        ")</span>"
                    );
                  } else {
                    autocompleteOption.append(
                      '<img src="' +
                        $("body").data("cdn-url") +
                        comps[key].property_image_url +
                        '" class="right circle"><span>' +
                        name +
                        " (Sold: no date available)</span>"
                    );
                  }
                } else {
                  if (comps[key].date_sold) {
                    autocompleteOption.append(
                      "<span>" +
                        name +
                        " (Sold: " +
                        comps[key].date_sold +
                        ")</span>"
                    );
                  } else {
                    autocompleteOption.append(
                      "<span>" + name + " (Sold: no date available)</span>"
                    );
                  }
                }

                $autocomplete.append(autocompleteOption);

                highlight(val, autocompleteOption);
              }
            }
          }
        },
        complete: function () {
          runningRequest = false;
        },
      });
      //},250);
    });
  } else {
    $input.autocomplete({
      data: options.data,
    });
  }
}

function initAutoCompleteForClients(options) {
  var defaults = {
    inputId: null,
    ajaxUrl: false,
    onSelect: false,
    data: {},
  };

  options = $.extend(defaults, options);

  var $input = $("#" + options.inputId);

  if (options.ajaxUrl !== false) {
    var $autocomplete = $(
        '<ul id="myId" class="autocomplete-content dropdown-content"></ul>'
      ),
      $inputDiv = $input.closest(".input-field"),
      //timeout,
      runningRequest = false,
      request;

    if ($inputDiv.length) {
      $inputDiv.append($autocomplete); // Set ul in body
    } else {
      $input.after($autocomplete);
    }

    var highlight = function (string, $el) {
      var img = $el.find("img");
      var matchStart = $el
          .text()
          .toLowerCase()
          .indexOf("" + string.toLowerCase() + ""),
        matchEnd = matchStart + string.length - 1,
        beforeMatch = $el.text().slice(0, matchStart),
        matchText = $el.text().slice(matchStart, matchEnd + 1),
        afterMatch = $el.text().slice(matchEnd + 1);
      $el.html(
        "<span>" +
          beforeMatch +
          "<span class='highlight'>" +
          matchText +
          "</span>" +
          afterMatch +
          "</span>"
      );
      if (img.length) {
        $el.prepend(img);
      }
    };

    $autocomplete.on("click", "li", function () {
      $input.val($(this).text().trim());
      $input.data("id", $(this).data("id"));
      $input.trigger("change");

      if (options.onAutocomplete) {
        options.onAutocomplete($input.data("id"));
      }

      $autocomplete.empty();

      if (typeof options.onSelect === "function") {
        options.onSelect($(this).data("id"));
      }
    });

    $input.on("keyup", function (e) {
      //if(timeout){ clearTimeout(timeout);}
      if (runningRequest) request.abort();

      if (e.which === 13) {
        $autocomplete.find("li").first().click();
        return;
      }

      var val = $input.val().toLowerCase();

      $autocomplete.empty();

      runningRequest = true;

      var ajaxData = { needle: val };

      if (options.limit) {
        ajaxData.limit = options.limit;
      }

      if (options.comp_id) {
        ajaxData.comp_id = options.comp_id;
      }

      request = $.ajax({
        type: "GET", // your request type
        url: $("body").data("base-url") + options.ajaxUrl,
        data: ajaxData,
        success: function (response) {
          var clients = JSON.parse(response);

          if (clients.length > 0) {
            for (var key in clients) {
              if (clients.hasOwnProperty(key)) {
                var autocompleteOption = $(
                  "<li data-id=" + clients[key].id + "></li>"
                );

                autocompleteOption.append(
                  "<span>" + clients[key].business_name + "</span>"
                );

                $autocomplete.append(autocompleteOption);

                highlight(val, autocompleteOption);
              }
            }
          }
        },
        complete: function () {
          runningRequest = false;
        },
      });
      //},250);
    });
  } else {
    $input.autocomplete({
      data: options.data,
    });
  }
}

$.fn.formatFloat = function () {
  this.each(function (i) {
    if (isNaN(parseFloat(this.value))) return;
    this.value = parseFloat(this.value).toFixed(2);
  });
  return this; //for chaining
};

$.fn.formatInt = function (suffix = "") {
  this.each(function (i) {
    if (isNaN(parseInt(this.value))) return;
    this.value = parseInt(this.value) + suffix;
  });
  return this; //for chaining
};

function initializeMasks(focus) {
  $(".currency").keypress(function (event) {
    if (
      (event.which != 46 || $(this).val().indexOf(".") != -1) &&
      (event.which < 48 || event.which > 57) &&
      (event.which != 45 || $(this).val().indexOf("-") > 0)
    ) {
      event.preventDefault();
    }
  });

  $(".currency-no-negative").keypress(function (event) {
    if (
      (event.which != 46 || $(this).val().indexOf(".") != -1) &&
      (event.which < 48 || event.which > 57)
    ) {
      event.preventDefault();
    }
  });

  $(".postmask-number, .postmask-percent").on("keypress", function (e) {
    if (
      !(
        (e.keyCode >= 48 && e.keyCode <= 57) ||
        e.keyCode === 46 ||
        e.keyCode === 45
      )
    ) {
      return false;
    }
  });

  $(document).on("keyup", ".postmask-integer", function () {
    x1 =
      $(this)
        .val()
        .replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",") || "";
    $(this).val(x1);
  });

  // $('.postmask-numberonly').on("keyup", function (e) {
  //     x1 = $(this).val().replace(/\D/g, '') || '';
  //     $(this).val(x1);
  // });

  $(document).on("keyup", ".postmask-currency", function (e) {
    maskCurrency(e, this);
  });

  $(document).on("blur", ".postmask-currency", function (e) {
    $(this).keyup();
  });

  $(document).on("keyup", ".postmask-percentage", function (e) {
    nStr =
      $(this)
        .val()
        .replace(/[^\d.-]/g, "") || "";
    if (e.keyCode == 8) {
      nStr = nStr.slice(0, -1);
    }
    if (nStr == "") {
      return $(this).val("");
    }
    if ($(this).hasClass("weight-percentage")) {
      var weight = parseFloat(nStr) / 100;
      if (weight <= 1) {
        chktoast = true;
        $(".submit-new-weight").attr("disabled", false);
      } else {
        $(".submit-new-weight").attr("disabled", true);
        if (chktoast) {
          Materialize.toast("Weight should be equal or under 100%.", 2000);
        }
        chktoast = false;
      }
    }
    x = nStr.split(".");
    x1 = x[0];
    x2 = x.length > 1 ? ("." + x[1]).substr(0, 3) : "";
    const rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, "$1" + "," + "$2");
    }
    $(this).val(x1 + x2 + "%");
  });

  $(".postmask-percentage-field").on("keyup", function (e) {
    maskPercentage(e, this);
  });

  $(".postmask-term").on("keyup", function (e) {
    nStr =
      $(this)
        .val()
        .replace(/[^\d.-]/g, "") || "";
    if (nStr == "") {
      return $(this).val("");
    }
    x = nStr.split(".");
    x1 = x[0];
    x2 = x.length > 1 ? ("." + x[1]).substr(0, 3) : "";
    $(this).val(x1 + x2);
  });

  $(document).on("keyup", ".postmask-money, .money-acre", function () {
    nStr = $(this).val().replace(/[^\d]/g, "");
    if (nStr == "") {
      return $(this).val("");
    }
    nStr = parseFloat(nStr).toString();
    if (nStr.length == 1) {
      if ($(this).hasClass("money-acre")) nStr = "0.00" + nStr;
      else nStr = "0.0" + nStr;
    } else if (nStr.length == 2) {
      if ($(this).hasClass("money-acre")) nStr = "0.0" + nStr;
      else nStr = "0." + nStr;
    } else if (nStr.length == 3 && $(this).hasClass("money-acre")) {
      nStr = "0." + nStr;
    } else {
      var data = nStr;
      var place = ".";
      if ($(this).hasClass("money-acre"))
        nStr = [data.slice(0, -3), place, data.slice(-3)].join("");
      else nStr = [data.slice(0, -2), place, data.slice(-2)].join("");
    }
    x = nStr.split(".");
    x1 = x[0];
    if ($(this).hasClass("money-acre"))
      x2 = x.length > 1 ? ("." + x[1]).substr(0, 4) : "";
    else x2 = x.length > 1 ? ("." + x[1]).substr(0, 3) : "";
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, "$1" + "," + "$2");
    }
    $(this).val(x1 + x2);
  });

  $(".postmask-number").on("blur", function (e) {
    nStr = $(this).val() || "";
    x = nStr.split(".");
    x1 = x[0];
    x2 = x.length > 1 ? ("." + x[1] + "00").substr(0, 3) : "";
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, "$1" + "," + "$2");
    }
    $(this).val(x1 + x2);
  });

  $(".postmask-percent").on("blur", function (e) {
    nStr = ($(this).val() || "").replace("%", "");
    x = nStr.split(".");
    x1 = x[0];
    x2 =
      x.length > 1
        ? ("." + x[1] + "00").substr(0, 3)
        : nStr !== ""
        ? ".00"
        : "";
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, "$1" + "," + "$2");
    }
    $(this).val(x1 + x2 + (nStr !== "" ? "%" : ""));
  });

  $(".phone_number").on("keyup", function (e) {
    phone = $(this).val().replace(/[^\d]/g, "") || "";
    if (e.keyCode == 8) {
      nStr = nStr.slice(0, -1);
    }
    if (phone.length < 3) {
      formatted = "(" + phone.substr(0, 3);
    } else if (phone.length >= 3 && phone.length < 6) {
      formatted = "(" + phone.substr(0, 3) + ") " + phone.substr(3, 3);
    } else {
      formatted =
        "(" +
        phone.substr(0, 3) +
        ") " +
        phone.substr(3, 3) +
        "-" +
        phone.substr(6, 4);
    }
    $(this).val(formatted);
  });

  $(document).on(
    "focus",
    ".money-acre, .postmask-number,.weight-percentage, .postmask-percent, .postmask-integer, .postmask-currency, .postmask-percentage, .standalone-datepicker, .filter-datepicker, .postmask-numberonly, .postmask-money, .postmask-percentage-field, .select-current-value, .postmask-currency-current",
    function (e) {
      this.select();
    }
  );

  $.fn.inputFilter = function (inputFilter) {
    return this.on(
      "input keydown keyup mousedown mouseup select contextmenu drop",
      function () {
        if (inputFilter(this.value)) {
          this.oldValue = this.value;
          this.oldSelectionStart = this.selectionStart;
          this.oldSelectionEnd = this.selectionEnd;
        } else if (this.hasOwnProperty("oldValue")) {
          this.value = this.oldValue;
          this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
        } else {
          this.value = "";
        }
      }
    );
  };
  $(".zipcode, .postmask-year, .ceiling, .postmask-numberonly").inputFilter(
    function (value) {
      return /^\d*$/.test(value); // Allow digits only, using a RegExp
    }
  );

  $(".money,.currency,.area,.percentage,.percent,.number,.space").bind(
    "paste",
    function (e) {
      $(this).val("");
    }
  );

  $(".money,.currency,.area,.percentage,.percent,.number,.space").bind(
    "click",
    function (e) {
      this.select();
    }
  );

  if (focus === true) {
    focusInMasks();
  }
  focusInPostMasks();
}

function maskPercentage(e, obj) {
  var sign = "";
  if ($(obj).val().indexOf("-") != -1) {
    sign = "-";
  }
  nStr =
    $(obj)
      .val()
      .replace(/[^\d.]/g, "") || "";
  if (nStr == "") {
    $(obj).val(sign);
    return;
  }
  if (e.keyCode == 8) {
    nStr = nStr.slice(0, -1);
  } else if (nStr.includes("100")) {
    nStr = "100";
  } else if (parseFloat(nStr) > 100) {
    nStr = nStr.substr(0, 2);
  }
  if (nStr == "") {
    return $(obj).val("");
  }
  x = nStr.split(".");
  x1 = x[0];
  x2 = x.length > 1 ? ("." + x[1]).substr(0, 3) : "";
  const rgx = /(\d+)(\d{3})/;
  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, "$1" + "," + "$2");
  }
  return $(obj).val(sign + x1 + x2 + "%");
}
function focusInMasks() {
  $(".currency,.area,.percentage,.number").each(function () {
    if ($(this).val().length) {
      $(this).maskMoney("mask", $(this).val());
      $(this).blur();
    }
  });

  $(".space").each(function () {
    var value = $(this).val();
    if (typeof value !== "string") {
      value = String(value);
    }
    value = value.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    $(this).val(value);
  });
}
function focusInPostMasks() {
  $(".postmask-integer").each(function () {
    if ($(this).val().length) {
      x1 =
        $(this)
          .val()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",") || "";
      $(this).val(x1);
    }
  });

  $(
    ".postmask-money, .postmask-currency, .money-acre, .postmask-currency-current"
  ).each(function () {
    if ($(this).val().length) {
      nStr =
        $(this)
          .val()
          .replace(/[^\d.-]/g, "")
          .replace("--", "-") || "0";
      x = nStr.split(".");
      x1 = x[0];
      if ($(this).hasClass("money-acre"))
        x2 = x.length > 1 ? ("." + x[1]).substr(0, 4) : ".000";
      else x2 = x.length > 1 ? ("." + x[1]).substr(0, 3) : ".00";
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, "$1" + "," + "$2");
      }
      if (
        $(this).hasClass("postmask-currency") ||
        $(this).hasClass("postmask-currency-current")
      ) {
        var value = "$" + x1 + x2;
        if (value.indexOf("-") != -1) {
          $(this).val(value.replace("$-", "-$"));
        } else {
          $(this).val(value);
        }
      } else {
        $(this).val(x1 + x2);
      }
    }
  });
  $(
    ".postmask-percentage, .postmask-percentage-field, .postmask-percentage-current"
  ).each(function (e) {
    if ($(this).val().length) {
      nStr =
        $(this)
          .val()
          .replace(/[^\d.-]/g, "") || "";
      if (nStr == "") {
        return $(this).val("");
      }
      x = nStr.split(".");
      x1 = x[0];
      x2 = x.length > 1 ? ("." + x[1]).substr(0, 3) : "";
      const rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, "$1" + "," + "$2");
      }
      $(this).val(x1 + x2 + "%");
    }
  });
}

function unmaskFields() {
  $(
    ".postmask-integer, .money-acre, .postmask-currency, .postmask-percentage, .postmask-money, .space, .postmask-percentage-current, .postmask-currency-current"
  ).each(function (index, value) {
    $(this).val(
      $(this)
        .val()
        .replace(/[^\d.-]/g, "")
    );
  });
}

function initializePropertyType() {
  if ($(".property-type-row").length > 0) {
    // Clone property type rows
    // TODO: these clone functions should be combined into one
    $(document).on("click", ".add-additional-property-type", function () {
      var propertyTypeRow = $(".property-type-row");
      var count = propertyTypeRow.length;

      var property_type_row = propertyTypeRow.last().clone();
      var error_html = $(propertyTypeRow)
        .find(".zonings.property_type")
        .next(".error").length;
      var msg =
        '<div id="zonings[index][zone]-error" class="error">This field is required.</div>';
      var msg_sub_zone =
        '<div id="zonings[index][sub_zone]-error" class="error">This field is required.</div>';
      var msg_sq_ft =
        '<div id="zonings[index][sq_ft]-error" class="error">This field is required.</div>';

      property_type_row.find("input:not(.hidden-field)").val("");
      property_type_row.find("input:not(.hidden-field)").val("");
      // property_type_row.find('.on_fly_zoning_label label').text('Additional Property Type');
      property_type_row
        .find(".on_fly_zoning_label label")
        .text("Property Type");
      propertyTypeRow.last().after(property_type_row);
      $(".property-type-row").last().find(".weight_sf").val(100);
      $(".property-type-row").last().find("select.property_type").val("");
      $(".property-type-row").last().find("select.property_sub_type").val("");
      $(".property-type-row")
        .last()
        .find("select.property_sub_type")
        .attr("disabled", true);
      $(".property-type-row")
        .last()
        .find(".select-wrapper")
        .removeClass("error");

      $(".property-type-row")
        .last()
        .find(".subzone-type-option")
        .addClass("enable-type-own");
      $(".property-type-row")
        .last()
        .find(".subzone-type-option")
        .addClass("subzone-type-option" + count);
      var remove = count - 1;
      $(".property-type-row")
        .last()
        .find(".subzone-type-option")
        .removeClass("subzone-type-option" + remove);

      $(".property-type-row")
        .last()
        .find("select.property_sub_type")
        .attr(
          "onchange",
          "change_custom_field(this,`subzone-type-option" +
            count +
            "`,`subzone_type_custom" +
            count +
            "`,`zone`)"
        );
      $(".property-type-row")
        .last()
        .find("#subzone_type_custom" + remove + "-error")
        .remove();
      $(".property-type-row")
        .last()
        .find(".subzone_type_custom")
        .attr("aria-describedby", "subzone_type_custom" + count + "-error");

      $(".property-type-row")
        .last()
        .find(".subzone_type_custom")
        .attr("id", "subzone_type_custom" + count);

      $(".property-type-row")
        .find(".zonings.property_type")
        .removeClass("error");
      $(".property-type-row")
        .find(".zonings.property_sub_type")
        .removeClass("error");
      $(".property-type-row")
        .find(".zonings.property_type")
        .next(".error")
        .remove();

      $(".property-type-row")
        .find(".zonings.property_sub_type")
        .next(".error")
        .remove();
      $(".property-type-row").find(".zonings.space").next(".error").remove();

      $(".property-type-row").find("select").material_select();
      iteratePropertyControls();
      updatePropertyTriggers();
      if (error_html > 0) {
        propertyTypeRow.first().find(".zonings.property_type").append(msg);
        propertyTypeRow
          .first()
          .find(".zonings.property_sub_type")
          .append(msg_sub_zone);
        propertyTypeRow.first().find(".zonings.zoning_space").append(msg_sq_ft);
      }
      // $('.space').each(function (index, value) {
      //     x1 = $(this).val().replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ",") || '';
      //     $(this).val(x1);
      // });
      if ($("#administrative_area_level_1").parent().hasClass("error")) {
        $("#administrative_area_level_1").parent().removeClass("error");
        $("label[for='states']").addClass("active");
      }
      if ($("#conditions").parent().hasClass("error")) {
        $("#conditions").parent().removeClass("error");
        $("label[for='condition']").addClass("active");
      }
      initializeMasks();
    });

    // Allow property types to be removed
    $(document).on("click", ".delete-additional-property-type", function () {
      $(this).closest(".property-type-row").remove();
      iteratePropertyControls();
      var propertyTypeRow = $(".property-type-row");
      var property_type_row = propertyTypeRow.first();
      property_type_row.find(".zonings.space").trigger("change");
      if (
        location.pathname.indexOf("/res_comps") == -1 &&
        location.pathname.indexOf("/res_evaluations") == -1
      ) {
        calculateBuildingSize();
      } else {
        calculateResBuildingSize();
      }
      let checkScreen = "";
      if (location.pathname.indexOf("evaluations/") !== -1) {
        checkScreen =
          $("#comparison_basis").val() == "Unit" &&
          $("#eval_multi_family").prop("checked") == true &&
          !ApproachCalculator.checkPropertyType();
      } else {
        checkScreen = !ApproachCalculator.checkPropertyType();
      }
      if (checkScreen) {
        $(".unit-section").addClass("hide");
      }
      ApproachCalculator.check_unit_val = ApproachCalculator.calculateUnits();
    });
    $(document).on("click", ".add-additional-unit-type", function () {
      var unitTypeRow = $(".unit-type-row");
      var unit_type_row = unitTypeRow.last().clone();
      var error_html = $(unitTypeRow)
        .find(".property_unit")
        .next(".error").length;
      var msg =
        '<div id="zonings[index][zone]-error" class="error">This field is required.</div>';
      var msg_sub_zone =
        '<div id="zonings[index][sub_zone]-error" class="error">This field is required.</div>';
      var msg_sq_ft =
        '<div id="zonings[index][sq_ft]-error" class="error">This field is required.</div>';
      $(".unit-type-row").last().after(unit_type_row);
      $(".unit-type-row").last().find(".bed_val").attr("value", "").val("");
      $(".unit-type-row").last().find(".bath_val").attr("value", "").val("");
      $(".unit-type-row").last().find(".Sq_ft").attr("value", "").val("");
      $(".unit-type-row")
        .last()
        .find(".unit_count_val")
        .attr("value", "")
        .val("");
      $(".unit-type-row")
        .last()
        .find(".avg_monthly_rent_val")
        .attr("value", "")
        .val("");
      $(".unit-type-row").last().find(".bed_val").next(".error").remove();
      $(".unit-type-row").last().find(".bath_val").next(".error").remove();
      $(".unit-type-row").last().find(".Sq_ft").next(".error").remove();
      $(".unit-type-row")
        .last()
        .find(".unit_count_val")
        .next(".error")
        .remove();
      $(".unit-type-row")
        .last()
        .find(".avg_monthly_rent_val")
        .next(".error")
        .remove();
      $(".unit-type-row")
        .last()
        .find('input[name="property_units[index][id]"]')
        .val("");
      iterateUnitControls();
      if (error_html > 0) {
        unitTypeRow.first().find(".bed_val").append(msg);
        unitTypeRow.first().find(".bath_val").append(msg_sub_zone);
        unitTypeRow.first().find(".Sq_ft").append(msg_sq_ft);
        unitTypeRow.first().find(".unit_count_val").append(msg_sq_ft);
        unitTypeRow.first().find(".avg_monthly_rent_val").append(msg_sq_ft);
      }
    });

    $(document).on("click", ".delete-additional-unit-type", function () {
      $(this).closest(".unit-type-row").remove();
      iterateUnitControls();
      $(".unit-type-row")
        .first()
        .find(".add-additional-unit-type")
        .removeClass("hide");
      ApproachCalculator.check_unit_val = ApproachCalculator.calculateUnits();
    });

    hideIfLand();
    iteratePropertyControls();
    updatePropertyTriggers();
  }
}

$(document).on("keyup", ".unit_count_val", function () {
  ApproachCalculator.check_unit_val = ApproachCalculator.calculateUnits();
});

$(document).on("keyup", ".of_units", function () {
  ApproachCalculator.check_unit_val = ApproachCalculator.calculateUnits();
});

$(document).on("change", ".select_comp_type", function (e) {
  var value = $(this).val();
  if (location.pathname.indexOf("/evaluations/overview") !== -1) {
    if ($("#selected_comp_type").length) {
      let selected_comp_type = $("#selected_comp_type").val();
      if (value != selected_comp_type) {
        let responseTxt = checkEvalChangePermission();
        var response = JSON.parse(responseTxt);
        if (response.status === "fail") {
          Materialize.toast(response.msg, 2000);
          $("#" + selected_comp_type).prop("checked", true);
          return;
        }
      }
    }
  }
  if (value == "land_only") {
    $(".hide-if-land-only").addClass("hide");
    $(".property_type_row").prop("required", false);
    $(".select_land_type").removeClass("hide");
    $(".land_type").prop("required", true);
    $(".land_type_field").addClass("required");
    $(".land_type_field").children("input").prop("required", true);
    if (
      $("[name='evaluation[land_type]']").val() == "Type My Own" ||
      $("[name='land_type']").val() == "Type My Own"
    ) {
      $(".land_type_field").removeClass("s6");
      $(".land_type_field").removeClass("s4");
      $(".land_type_field").addClass("s3");
      $(".select_land_type").removeClass("s4");
      $(".select_land_type").addClass("s6");
    } else {
      $(".land_type_field").removeClass("s3");
      $(".land_type_field").removeClass("s6");
      $(".land_type_field").addClass("s4");
      $(".select_land_type").removeClass("s6");
      $(".select_land_type").addClass("s4");
    }

    $(".property-type-row").hide();
    $(".zoning_block").hide();

    if (location.pathname.indexOf("/evaluations/overview") !== -1) {
      $(".analysis_hide").removeClass("hide");
      $(".land_dimension_select").addClass("hide");
    }
  } else {
    $(".hide-if-land-only").removeClass("hide");
    $(".property-type-row").show();
    $(".property_type_row").prop("required", true);
    $(".select_land_type").addClass("hide");
    $(".land_type").prop("required", false);
    $(".land_type_field").removeClass("s4");
    $(".land_type_field").addClass("s6");
    $(".zoning_block").show();
    $(".land_type_field").removeClass("required");
    $(".land_type_field").children("input").prop("required", false);
    $(".land_type_field").children("div.error").remove();
    if (location.pathname.indexOf("/evaluations/overview") !== -1) {
      $(".analysis_hide").addClass("hide");
      $(".land_dimension_select").removeClass("hide");
    }
  }
  if (location.pathname.indexOf("/evaluations/overview") !== -1) {
    check_cap_comp_display();
    setDefaultWeight();
    if ($("#landdimension").val() == "SF") {
      $("#analysis_type").val("$/SF");
    } else {
      $("#analysis_type").val("$/Acre");
    }
    $("#analysis_type").material_select();
  }
  if ($(".check_fields").length) {
    if (
      ($(".select_type:checked").val() !== "sale" || value == "land_only") &&
      $(".check_fields").hasClass("hide-if-land-only") &&
      $(".check_fields").attr("data-ref") == "sale"
    ) {
      $(".check_fields").addClass("hide");
    } else {
      $(".check_fields").removeClass("hide");
    }
  }
});

function checkEvalChangePermission() {
  let responseTxt = "";
  var id = $('input[name="evaluation[id]"]').val();
  $.ajax({
    type: "GET",
    async: false,
    url: $("body").attr("data-base-url") + "evaluations/checkEval",
    data: { id: id },
    success: function (response) {
      responseTxt = response;
    },
  });
  return responseTxt;
}

$(document).on("change", "#comparison_basis", function (e) {
  let value = $(this).val();
  if (location.pathname.indexOf("/evaluations/overview") !== -1) {
    if ($("#comparison_basis_field").length) {
      let comparison_basis_field = $("#comparison_basis_field").val();
      if (value != comparison_basis_field) {
        let responseTxt = checkEvalChangePermission();
        var response = JSON.parse(responseTxt);
        if (response.status === "fail") {
          Materialize.toast(response.msg, 2000);
          $(this).val(comparison_basis_field).material_select();
          return;
        }
      }
    }
  }
  if (value == "Unit") {
    $(".show-if-unit").removeClass("hide");
    $(".show-if-bed").addClass("hide");
    if (location.pathname.indexOf("/comps") != -1) {
      $(".property_width").removeClass("s3").addClass("s4");
    } else {
      $(".property_width").removeClass("s3").addClass("s2");
    }
    $(".subzone_width").removeClass("s4").addClass("s3");
    $(".show-if-unit").find("input").attr("required", true);
    $(".show-if-bed").find("input").removeAttr("required");
    let checkScreen = "";
    if (location.pathname.indexOf("evaluations/") !== -1) {
      checkScreen =
        $("#eval_multi_family").prop("checked") !== false &&
        ApproachCalculator.checkPropertyType();
    } else {
      checkScreen = ApproachCalculator.checkPropertyType();
    }
    if (checkScreen) {
      $(".unit-section").removeClass("hide");
    }
  } else if (value == "Bed") {
    $(".show-if-unit").addClass("hide");
    $(".show-if-bed").removeClass("hide");
    if (location.pathname.indexOf("/comps") != -1) {
      $(".property_width").removeClass("s3").addClass("s4");
    } else {
      $(".property_width").removeClass("s3").addClass("s2");
    }
    $(".subzone_width").removeClass("s4").addClass("s3");
    $(".show-if-unit").find("input").removeAttr("required");
    $(".show-if-bed").find("input").attr("required", true);
    $(".unit-section").addClass("hide");
  } else {
    $(".show-if-unit").addClass("hide");
    $(".show-if-bed").addClass("hide");
    if (location.pathname.indexOf("/comps") != -1) {
      $(".property_width").removeClass("s3").addClass("s4");
    } else {
      $(".property_width").removeClass("s32").addClass("s3");
    }
    $(".subzone_width").removeClass("s3").addClass("s4");
    $(".show-if-unit").find("input").removeAttr("required");
    $(".show-if-bed").find("input").removeAttr("required");
    $(".unit-section").addClass("hide");
  }
});

$(document).on("keyup", ".space", function () {
  if (
    location.pathname.indexOf("/res_comps") == -1 &&
    location.pathname.indexOf("/res_evaluations") == -1
  ) {
    calculateBuildingSize();
  } else {
    calculateResBuildingSize();
  }
});

var removePropertyTypeRow = function () {
  $(".property-type-row").each(function (i, val) {
    if (i !== 0) {
      $(val).remove();
    }
  });

  $(".property-type-row")
    .find(".zonings.property_type")
    .next(".error")
    .remove();
  $(".property-type-row")
    .find(".zonings.property_sub_type")
    .next(".error")
    .remove();
  $(".property-type-row").find(".zonings.space").next(".error").remove();
  $("input[name='zonings[index][id]']").val("");
  $("select[name='zonings[index][zone]']")[0].selectedIndex = 0;
  $("select[name='zonings[index][sub_zone]']")
    .find("option")
    .remove()
    .end()
    .append(
      $("<option>", {
        value: "",
        text: "-- Select a Subtype --",
      })
    );
  $("input[name='zonings[index][sq_ft]']").val("");
  $("select[name='zonings[index][zone]']").material_select();
  $("select[name='zonings[index][sub_zone]']").material_select();
  $(".property-type-row").hide();
  $(".additional-property-type").removeClass("hide");
};

var hideIfLand = function () {
  var hasLand = false;
  var suiteOrParcel;

  $("select.property_type").each(function () {
    if ($(this).val() === "land") {
      $("#comps_sq_ft_field").hide();
      hasLand = true;
    } else {
      $("#comps_sq_ft_field").show();
    }
  });

  if (!hasLand) {
    if ($(".hide-if-land").hasClass("hide")) {
      $(".hide-if-land").removeClass("hide");
    }
    $("#suite-or-parcel-span").html("Suites");
    suiteOrParcel = "SUITE";
  } else {
    $(".hide-if-land").addClass("hide");
    $("#suite-or-parcel-span").html("Parcels");
    suiteOrParcel = "PARCEL";
  }

  $("input[name='suites_parcels[index][type]']").each(function () {
    $(this).val(suiteOrParcel);
  });
};

var updatePropertyTriggers = function () {
  $(".property-type-row").each(function () {
    var subInput = $(this).find("select.property_sub_type");
    var subType = subInput.attr("data-subtype");

    $(this)
      .find("select.property_type")
      .on("change", function () {
        var value = $(this).val();
        var sub = $.parseJSON(subType);
        var options = "";

        if (typeof sub[value] !== "undefined") {
          var children = sub[value].children;
          if (typeof children !== "undefined") {
            for (var child in children) {
              options +=
                "<option value='" +
                child +
                "'>" +
                children[child] +
                "</option>";
              $(subInput).attr("disabled", false);
            }
          } else {
            options = "<option value='0'>No Subtypes</option>";
            $(subInput).attr("disabled", true);
          }
        } else {
          options += "<option value=''>-- Select a Subtype --</option>";
        }

        $(subInput).html(options).material_select();
        $(subInput).parent().removeClass("error");
        $(subInput).removeClass("error");
        if ($(subInput).parent().next().hasClass("error")) {
          $(subInput).parent().next().remove();
        }

        hideIfLand();
      });

    $(this).find("select.property_type").material_select();
    $(this).find("select.property_sub_type").material_select();
  });
  iteratePropertyControls();
  hideIfLand();
  if (
    location.pathname.indexOf("/res_comps") == -1 &&
    location.pathname.indexOf("/res_evaluations") == -1
  ) {
    calculateBuildingSize();
  } else {
    calculateResBuildingSize();
  }
};

var calculateResBuildingSize = function () {
  var totalsf = 0;
  $(".property-type-row").each(function () {
    let sf = 0;
    let gross_living_sq_ft = $(this)
      .find('.zonings[data-attribute="gross_living_sq_ft"]')
      .val()
      .replace(/\$|\s|[, ]/g, "");
    let basement_finished_sq_ft = $(this)
      .find('.zonings[data-attribute="basement_finished_sq_ft"]')
      .val()
      .replace(/\$|\s|[, ]/g, "");
    let basement_unfinished_sq_ft = $(this)
      .find('.zonings[data-attribute="basement_unfinished_sq_ft"]')
      .val()
      .replace(/\$|\s|[, ]/g, "");
    if (gross_living_sq_ft == "") gross_living_sq_ft = 0;
    if (basement_finished_sq_ft == "") basement_finished_sq_ft = 0;
    if (basement_unfinished_sq_ft == "") basement_unfinished_sq_ft = 0;

    sf +=
      parseInt(gross_living_sq_ft) +
      parseInt(basement_finished_sq_ft) +
      parseInt(basement_unfinished_sq_ft);
    $(this).find('.zonings[data-attribute="sq_ft"]').val(sf).change();
    totalsf += parseInt(sf);
  });
  if ($('[name="building_size"]').length > 0) {
    // if (totalsf > 0) {
    $('[name="building_size"]').val(totalsf).change();
    // }
  }
  if (
    $('[name="evaluation[building_size]"]').length > 0 &&
    location.pathname.indexOf("evaluations/overview") !== -1
  ) {
    // if (totalsf > 0) {
    $('[name="evaluation[building_size]"]').val(totalsf).trigger("change");
    // }
  }
  if (location.pathname.indexOf("/res_comps") !== -1) {
    setPriceSquareFoot();
  }
};

var calculateBuildingSize = function () {
  var zonings = $('.zonings[data-attribute="sq_ft"]');

  if (zonings.length > 0) {
    var total = 0;
    zonings.each(function (i, el) {
      var input = $(el);
      var val = input.val().replace(/\$|\s|[, ]/g, "");

      if (val && !isNaN(val)) {
        total += parseInt(val);
      }
    });
    if ($('[name="comp[building_size]"]').length > 0) {
      // if (total > 0) {
      $('[name="comp[building_size]"]').val(total).trigger("change");
      // }
    }
    if (
      $('[name="evaluation[building_size]"]').length > 0 &&
      location.pathname.indexOf("/evaluations/overview") !== -1
    ) {
      // if (total > 0) {
      $('[name="evaluation[building_size]"]').val(total).trigger("change");
      // }
    }
    if ($('[name="building_size"]').length > 0) {
      // if (total > 0) {
      $('[name="building_size"]').val(total).trigger("change");
      $(".area").maskMoney("mask", total);
      setPriceSquareFoot();
      // }
    }
  }
};

var iteratePropertyControls = function () {
  var propertyTypeRow = $(".property-type-row");
  // Loop through the rows and hide/show our add/remove buttons as necessary
  var rows = propertyTypeRow.length;

  propertyTypeRow.each(function (i) {
    if (rows > i + 1) {
      $(this).find(".additional-property-type").addClass("hide");
      $(this).find(".weight-text").addClass("hide");
    } else if (rows === i + 1) {
      $(this).find(".additional-property-type").removeClass("hide");
      $(this).find(".weight-text").removeClass("hide");
    }

    if (i > 0) {
      $(this).find(".delete-additional-property-type").removeClass("hide");
    }
  });
};

var iterateUnitControls = function () {
  var unitTypeRow = $(".unit-type-row");
  // Loop through the rows and hide/show our add/remove buttons as necessary
  var rows = unitTypeRow.length;

  unitTypeRow.each(function (i) {
    if (rows > i + 1) {
      $(this).find(".additional-unit-type").addClass("hide");
    } else if (rows === i + 1) {
      $(this).find(".additional-unit-type").removeClass("hide");
    }
    if (i > 0) {
      $(this).find(".delete-additional-unit-type").removeClass("hide");
    }
    if (location.search.indexOf("/multiFamilyComps") !== -1) {
      $(".delete-additional-unit-type").addClass("hide");
      $(".add-additional-unit-type").addClass("hide");
    }
  });
};
var autoCompleteBrokerage = function () {
  // var autocomplete = new google.maps.places.Autocomplete(
  //     (document.getElementById('account_name')), {
  //     types: ['establishment']
  // });

  autocomplete.addListener("place_changed", function () {
    $("#account_name").val("");
    $("#city").val("");
    $("#state").val("");
    $("#zipcode").val("");
    $("#g_place_id").val("");

    var place = autocomplete.getPlace();
    var place_name = place.name;

    var zipcode = "";
    var city = "";
    var state = "";
    var place_id = place.place_id;

    $(place.address_components).each(function (i, el) {
      //zipcode
      if ($.inArray("postal_code", el.types) !== -1) {
        zipcode = el.long_name;
      }

      if (
        $.inArray("locality", el.types) !== -1 &&
        $.inArray("political", el.types) !== -1
      ) {
        city = el.long_name;
      }

      if (
        $.inArray("administrative_area_level_1", el.types) !== -1 &&
        $.inArray("political", el.types) !== -1
      ) {
        state = el.short_name.toLowerCase();
      }
    });

    $("#account_name").val(place_name);
    $("#city").val(city);
    $('select[name="state"]').val(state);
    $('select[name="state"]').material_select();
    $("#zipcode").val(zipcode);
    $("#g_place_id").val(place_id);
    $("#street_address").attr("value", place.formatted_address);
  });
};

function toNumberFromPercent(el) {
  if (el.length) {
    if ($(el).val() && $(el).val().length) {
      var weightField = $(el).val().replace(/,/g, ".");
      // var weightField = $(el).masked($(el).val()).replace(/,/g, '.');
      if (weightField.length) {
        return parseFloat(weightField) / 100;
      }
    }
  }

  return 0.0;
}
function changeRole() {
  var old_role = $("#role_id").val();
  $("#user_role").val(old_role);
  var $select1 = $("select.role");
  $select1.material_select();
}

$(document).on("change", ".master-file-input", function () {
  var key = $(this).attr("name");
  var id = $(this).attr("data-id");

  if (this.files && this.files[0]) {
    var reader = new FileReader();
    $(".master-property-span").hide();
    $(".master-property-image").removeClass("add-image");

    reader.onload = function (e) {
      var img = $("img[data-key='" + key + "']");
      img.attr("src", e.target.result);
      img.css("object-fit", "cover");
    };
    reader.readAsDataURL(this.files[0]);
    upload(this.files[0], id, key, "Master_properties/upload_image");
  }
});

function upload(file, id, key, url = null, bit = false) {
  var formData;
  if (bit) {
    formData = file;
  } else {
    formData = new FormData();
    formData.append("file", file);
    formData.append("id", id);
    formData.append("field", key);
    formData.append("file_name", key);
  }

  var image_container = "#show_image_upload_" + key;
  var progress_container = "#show_image_upload_" + key;
  var progress_bar = "#myprogress_" + key;
  var action_button = "#action_button_" + key;

  if (key == "extra-image") {
    image_container = "#extra_image_upload_section";
    progress_container = "#show_extra_image_upload_progress";
    progress_bar = "#extra_image_progress";
  }

  $(image_container).hide();

  $.ajax({
    type: "POST",
    url: $("body").attr("data-base-url") + url,
    data: formData,
    contentType: false,
    processData: false,
    beforeSend: function () {
      startLoading("body");
    },
    xhr: function () {
      var xhr = new XMLHttpRequest();
      xhr.upload.addEventListener(
        "progress",
        function (evt) {
          if (evt.lengthComputable) {
            var percentComplete = evt.loaded / evt.total;
            percentComplete = parseInt(percentComplete * 100);
            $(progress_container).show();
            $(progress_bar).css("background-color", "#7dcce1");
            $(progress_bar).text(percentComplete + "%");
            $(progress_bar).css("width", percentComplete + "%");
          }
        },
        false
      );
      return xhr;
    },
    success: function (responseTxt) {
      $("#save_image").attr("disabled", false);
      var response = JSON.parse(responseTxt);

      if (response.status === "success") {
        if (
          location.pathname.indexOf("/master-properties") !== -1 ||
          location.pathname.indexOf("/res-master-properties") !== -1
        ) {
          $(image_container)
            .find(".eval-image")
            .attr("src", $("body").attr("data-cdn-url") + response.dir);
        } else {
          $(image_container)
            .find(".eval-image")
            .attr(
              "src",
              $("#uploadEvalImage")
                .find("#image")
                .cropper("getCroppedCanvas")
                .toDataURL()
            );
        }
        $(image_container).find("img").css("object-fit", "cover");
        Materialize.toast("The image has been saved.", 2000);
        var action =
          '<a href="#view" class="tooltipped modal-trigger" data-dir="' +
          response.dir +
          '" data-position="bottom" data-delay="50" data-tooltip="View">' +
          '<img class="edit" src="' +
          $("body").attr("data-base-url") +
          "/assets/img/visibility-button.png" +
          '">' +
          "</a>&nbsp;" +
          '<a href="#!" class="tooltipped delete-image" data-file-id="' +
          response.fileId +
          '" data-file-field="' +
          key +
          '" data-eval-id="' +
          id +
          '" data-position="bottom" data-delay="50" data-tooltip="Delete" >' +
          '<img class="delete" src="' +
          $("body").attr("data-base-url") +
          "/assets/img/delete.png" +
          '">' +
          "</a>";

        $(action_button).html(action);
      } else if (response.status === "fail") {
        var img_src = $("#large_" + key).val();
        if (img_src == undefined)
          $("div" + image_container + " img").attr("src", "");
        else $("div" + image_container + " img").attr("src", img_src);
        Materialize.toast(
          "Image size is too large. Please upload a smaller file.",
          3000,
          "red"
        );
      }
    },
  }).done(function () {
    $("#image").cropper("destroy");
    $('.eval-image-container[data-key="' + key + '"]').LoadingOverlay("hide");
    $(".delete-image").tooltip();
    $(".modal-trigger").tooltip();
    if (key == "extra-image") window.location.reload();
    else stopLoading("body");
  });
}

function close_upload_comps_image() {
  var form = $("#uploadEvalImage");
  $("#image").cropper("destroy");
  form.find("input:text, input:file").val("");
  $(".comps-image").fadeTo("fast", 1);
  var output = $(".comps-image-container");
  output.css({ background: "" });
  $("#save_image").attr("disabled", false);
}

$(document).on("click", ".delete-image", function () {
  deleteConfirm(function (obj) {
    var id = obj.attr("data-file-id");
    var field = obj.attr("data-file-field");
    var dir = obj.attr("data-file-dir");
    var eval_id = obj.attr("data-eval-id");

    if (field) {
      $('.eval-image-container[data-key="' + field + '"]').LoadingOverlay(
        "show",
        {
          image: $("body").attr("data-base-url") + "assets/img/loading.png",
          imageAnimation: "2500ms rotate_left",
          zIndex: 1005,
          background: "rgb(250, 250, 250)",
        }
      );
    } else if (dir) {
      $('.eval-image-container[data-key="' + id + '"]').LoadingOverlay("show", {
        image: $("body").attr("data-base-url") + "assets/img/loading.png",
        imageAnimation: "2500ms rotate_left",
        zIndex: 1005,
        background: "rgb(250, 250, 250)",
      });
    }

    var url = "evaluations/remove_image";
    if (location.pathname.indexOf("/res_evaluations/images") !== -1) {
      url = "res_evaluations/remove_image";
    }

    $.ajax({
      type: "POST",
      url: $("body").attr("data-base-url") + url,
      data: {
        id: id,
        eval_id: eval_id,
        field: field,
        dir: dir,
      },
      success: function (responseTxt) {
        var response = JSON.parse(responseTxt);

        if (response.status === "success") {
          Materialize.toast("The image has been removed.", 2000);
          $("#action_button_" + field).html("");
          var img = $("img[data-key='" + field + "']");
          img.attr("src", "");
          if ($(obj).parent().parent().parent().children().length > 0) {
            var text = $(obj)
              .parent()
              .parent()
              .parent()
              .children()
              .closest("div.col.s3.description")[0].innerText;
            if (text === "Additional image") {
              $(obj).parent().parent().parent().remove();
            }
          }
        }
      },
    }).done(function () {
      if (field) {
        $('.eval-image-container[data-key="' + field + '"]').LoadingOverlay(
          "hide"
        );
      } else if (dir) {
        $('.eval-image-container[data-key="' + id + '"]').LoadingOverlay(
          "hide"
        );
      }
      if ($(".loadingoverlay_element").length)
        $(".loadingoverlay_element").hide();
    });
  }, $(this));
});
function checkweight(e) {
  nStr =
    $("#weight")
      .val()
      .replace(/[^\d.-]/g, "") || "";
  if (e.keyCode == 8) {
    nStr = nStr.slice(0, -1);
  }
  if (nStr == "") {
    return $("#weight").val("");
  }
  if ($("#weight").hasClass("weight-percentage")) {
    var weight = parseFloat(nStr) / 100;
    if (weight <= 1) {
      chktoast = true;
      $(".submit-new-weight").attr("disabled", false);
    } else {
      $(".submit-new-weight").attr("disabled", true);
      if (chktoast) {
        Materialize.toast("Weight should be equal or under 100%.", 2000);
      }
      chktoast = false;
    }
  }
  x = nStr.split(".");
  x1 = x[0];
  x2 = x.length > 1 ? ("." + x[1]).substr(0, 3) : "";
  $("#weight").val(x1 + x2 + "%");
}
$(document).ready(function () {
  $("#landdimension").change(function () {
    if ($(this).val() == "ACRE") {
      $("#landsize").addClass("money-acre");
      $("#landsize").removeClass("postmask-integer");
      if ($("#landsize").val()) $("label[for='land_size']").addClass("active");
      if (location.pathname.indexOf("/evaluations/overview") !== -1) {
        $("#analysis_type").val("$/Acre");
        $("#analysis_type").material_select();
      }
    }
    if ($(this).val() == "SF") {
      $("#landsize").addClass("postmask-integer");
      $("#landsize").removeClass("money-acre");
      var landsize = parseInt(
        $("#landsize")
          .val()
          .replace(/[^\d.]/g, "")
      )
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      $("#landsize").val(landsize);
      if (location.pathname.indexOf("/evaluations/overview") !== -1) {
        $("#analysis_type").val("$/SF");
        $("#analysis_type").material_select();
      }
    }
    initializeMasks();
  });
});

function get_company_or_client(obj, name, btn = null, selected = null) {
  var type = $(obj).val();
  if (type == "person" && btn != null) {
    $("#" + btn)
      .attr("data-tooltip", "Create a new Person")
      .tooltip();
  } else if (type == "company" && btn != null) {
    $("#" + btn)
      .attr("data-tooltip", "Create a new Company")
      .tooltip();
  } else if (type == "" && btn != null) {
    $("#" + btn)
      .attr("data-tooltip", "Select Type First")
      .tooltip();
  }
  $.ajax({
    type: "POST", // your request type
    async: false,
    url: $("body").data("base-url") + "clients/get_company_or_client",
    data: { type: type },
    success: function (response) {
      $('[name="' + name + '"]')
        .find("option")
        .remove()
        .end()
        .append(response);
      $('[name="' + name + '"]')
        .val(selected)
        .material_select();
    },
  });
}

function check_user_type(type) {
  $(".zonings").each(function () {
    $(this).removeClass("error");
    if ($(this).parent().children().find("div").hasClass("error")) {
      $(this).parent().children().find("div.error").remove();
    }
  });
  $("#administrative_area_level_1-error").remove();
  $("#administrative_area_level_1").removeClass("error");
  $("#conditions").removeClass("error");
  $("#conditions-error").remove();
  $("select[name='lease_type']").removeClass("error");
  $("#lease_type-error").remove();
  var type_slected = $("[name='" + type + "']").val();
  if (type_slected == "") {
    Materialize.toast("Please select type first.", 2000, "red");
  } else {
    open_modal_form(type);
  }
}

function open_modal_form(type) {
  var type_slected = $("[name='" + type + "']").val();
  if (type_slected == "person") {
    $("#add_client").attr("data-object", type);
    $("#add_client").modal({ dismissible: false });
    $("#add_client").modal("open");
  } else if (type_slected == "company") {
    $("#add_company").attr("data-object", type);
    $("#add_company").modal({ dismissible: false });
    $("#add_company").modal("open");
  } else {
    $("#" + type).modal({ dismissible: false });
    $("#" + type).modal("open");
  }
}

$(document).on("click", "#save-company", function () {
  var form = $("form#add_company-form");
  if (form.valid()) {
    event.preventDefault();
    var data = new FormData(form[0]);
    $.ajax({
      type: "POST",
      url: $("body").data("base-url") + "company/saveCompany",
      data: data,
      cache: false,
      contentType: false,
      processData: false,
      beforeSend: function () {
        $("body").LoadingOverlay("show", {
          image: $("body").attr("data-base-url") + "assets/img/loading.png",
          imageAnimation: "2500ms rotate_left",
          zIndex: 1020,
          background: "rgba(255, 255, 255, 0.95)",
        });
      },
      success: function (responseText) {
        if (responseText == "already exist") {
          Materialize.toast("Company name is already exist.", 2000, "red");
        } else {
          var response = JSON.parse(responseText);
          Materialize.toast(response.response, 2000);
          $("#add_company").modal("close");
          reset_company_modal();
          var type = $("#add_company").attr("data-object");
          var selected = "";
          if (type == "offeror_type") {
            get_company_or_client(
              "#offeror_type",
              "offeror_id",
              null,
              response.id
            );
          } else {
            selected = $('[name="offeror_id"]').val();
            get_company_or_client(
              "#offeror_type",
              "offeror_id",
              null,
              selected
            );
          }
          if (type == "acquirer_type") {
            get_company_or_client(
              "#acquirer_type",
              "acquirer_id",
              null,
              response.id
            );
          } else {
            selected = $('[name="acquirer_id"]').val();
            get_company_or_client(
              "#acquirer_type",
              "acquirer_id",
              null,
              selected
            );
          }
        }
      },
      failure: function (errMsg) {
        Materialize.toast("It was not possible to execute that action.", 2000);
      },
    }).done(function () {
      $("body").LoadingOverlay("hide");
    });
  } else {
    Materialize.toast("Please complete the missing fields.", 3000, "blue");
  }
});

$(document).on("click", "#save-client", function () {
  var form = $("form#add_client-form");
  if (form.valid()) {
    event.preventDefault();
    var data = new FormData(form[0]);
    $.ajax({
      type: "POST",
      url: $("body").data("base-url") + "clients/saveClient",
      data: data,
      cache: false,
      contentType: false,
      processData: false,
      beforeSend: function () {
        $("body").LoadingOverlay("show", {
          image: $("body").attr("data-base-url") + "assets/img/loading.png",
          imageAnimation: "2500ms rotate_left",
          zIndex: 1020,
          background: "rgba(255, 255, 255, 0.95)",
        });
      },
      success: function (responseText) {
        var response = JSON.parse(responseText);
        Materialize.toast(response.response, 2000);
        $("#add_client").modal("close");
        reset_client_modal();
        var type = $("#add_client").attr("data-object");
        var selected = "";
        if (type == "offeror_type") {
          get_company_or_client(
            "#offeror_type",
            "offeror_id",
            null,
            response.id
          );
        } else {
          selected = $('[name="offeror_id"]').val();
          get_company_or_client("#offeror_type", "offeror_id", null, selected);
        }
        if (type == "acquirer_type") {
          get_company_or_client(
            "#acquirer_type",
            "acquirer_id",
            null,
            response.id
          );
        } else {
          selected = $('[name="acquirer_id"]').val();
          get_company_or_client(
            "#acquirer_type",
            "acquirer_id",
            null,
            selected
          );
        }
      },
      failure: function (errMsg) {
        Materialize.toast("It was not possible to execute that action.", 2000);
      },
    }).done(function () {
      $("body").LoadingOverlay("hide");
    });
  } else {
    Materialize.toast("Please complete the missing fields.", 3000, "blue");
  }
});
$(document).on(
  "click",
  ".company_modal_close, .client_modal_close, .coupon_modal_close",
  function () {
    reset_company_modal();
    reset_client_modal();
    reset_coupon_modal();
  }
);

$(document).on("click", "#save-coupon", function () {
  var form = $("form#add_coupon-form");
  if (form.valid()) {
    event.preventDefault();
    var data = new FormData(form[0]);
    $.ajax({
      type: "POST",
      url: $("body").data("base-url") + "settings/saveCoupon",
      data: data,
      cache: false,
      contentType: false,
      processData: false,
      beforeSend: function () {
        $("body").LoadingOverlay("show", {
          image: $("body").attr("data-base-url") + "assets/img/loading.png",
          imageAnimation: "2500ms rotate_left",
          zIndex: 1020,
          background: "rgba(255, 255, 255, 0.95)",
        });
      },
      success: function (responseText) {
        if (responseText == "1") {
          Materialize.toast("Successfully Added", 2000);
          window.location.href = "#promo_codes";
          location.reload();
          // reset_coupon_modal();
          // $("#add_coupon").modal('close');
        } else {
          Materialize.toast(responseText, 2000);
          $("body").LoadingOverlay("hide");
        }
      },
      failure: function (errMsg) {
        Materialize.toast("It was not possible to execute that action.", 2000);
        $("body").LoadingOverlay("hide");
      },
    }).done(function () {
      // $('body').LoadingOverlay("hide");
    });
  } else {
    Materialize.toast("Please complete the missing fields.", 3000, "blue");
  }
});

function reset_coupon_modal() {
  $("#promo_code-error").remove();
  $('[name="promo_code"]').removeClass("error");
  $('[name="promo_code"]').val("");
  $("label[for='promo_code']").removeClass("active");
  $("#redeem_by-error").remove();
  $('[name="redeem_by"]').removeClass("error");
  $('[name="redeem_by"]').val("");
  $("label[for='redeem_by']").removeClass("active");
  $("#months_free-error").remove();
  $('[name="months_free"]').removeClass("error");
  $('[name="months_free"]').val("");
  $("label[for='months_free']").removeClass("active");
}

function reset_company_modal() {
  $("#company_name-error").remove();
  $('[name="company_name"]').removeClass("error");
  $('[name="company_name"]').val("");
  $("label[for='company_name']").removeClass("active");
  var account_id = $("#logged_user_account_id").val();
  $('[name="account_id"]').val(account_id).material_select();
}

function reset_client_modal() {
  $("#first_name-error").remove();
  $('[name="first_name"]').removeClass("error");
  $('[name="first_name"]').val("");
  $("label[for='first_name']").removeClass("active");
  $("#last_name-error").remove();
  $('[name="last_name"]').removeClass("error");
  $('[name="last_name"]').val("");
  $("label[for='last_name']").removeClass("active");
  $('[name="email_address"]').val("");
  $("label[for='email_address']").removeClass("active");
  var account_id = $("#logged_user_account_id").val();
  $('[name="account_id"]').val(account_id).material_select();
}
function setDefaultWeight() {
  var approachs = "";
  if ($("#income_approach").length && $("#income_approach").is(":checked")) {
    approachs = "1";
  } else {
    approachs = "0";
  }
  if (
    $("#sales_comparison_approach").length &&
    $("#sales_comparison_approach").is(":checked")
  ) {
    approachs = approachs + "1";
  } else {
    approachs = approachs + "0";
  }
  if ($("#cost_approach").length) {
    if ($("#cost_approach").is(":checked")) {
      approachs = approachs + "1";
    } else {
      approachs = approachs + "0";
    }
  }
  var eval_type = "";
  if ($(".select_comp_type:checked").length)
    eval_type = $(".select_comp_type:checked").val();
  else eval_type = "building_with_land";

  approachs = approachs + eval_type;
  if ($("#compare_approachs").val() != approachs) {
    $("#change_approaches").val("1");
  } else {
    $("#change_approaches").val("0");
  }
}

function printDiv(divId) {
  $("#partially_added_comps_modal").modal({ dismissible: true });
  $(".modal-close").hide();
  var title = document.title;
  document.title = "Comps List";
  $("#" + divId)
    .clone()
    .appendTo("#print-me");
  $(".list").hide();
  $("header").hide();
  $("footer").hide();
  window.print();
  document.title = title;
  $(".list").show();
  $("body").removeClass("printing");
  $("header").show();
  $("footer").show();
  $("#print-me").empty();
  $(".modal-close").show();
  $("#partially_added_comps_modal").modal("open");
}

function change_subscription(update = null) {
  var value = $(".change_subscription:checked").val();
  var accountId = $("#account_id").val();
  if (update !== 1) {
    $("body").LoadingOverlay("show", {
      image: $("body").attr("data-base-url") + "assets/img/loading.png",
      imageAnimation: "2500ms rotate_left",
      zIndex: 1005,
      background: "rgba(255, 255, 255, 0.95)",
    });
  }
  if (value == "account-level") {
    $.ajax({
      method: "POST",
      url: $("body").attr("data-base-url") + "accounts/get_account_users",
      data: { accountId: accountId },
    }).done(function (data) {
      $("body").LoadingOverlay("hide");
      if (data == "fail") {
        $("#response").html(
          "<strong>There are already users with active subscriptions in your account. Please contact Harken for assistance making this change.</strong>"
        );
      } else {
        $("#response").html(data);
        if (data == "No record found") {
          $("#response").html("<strong>" + data + "</strong>");
          $(".payment_div").addClass("hide");
        } else {
          $(".payment_div").removeClass("hide");
        }
      }
      if (data !== "No record found") {
        var user_count = $("#user_count").val();
        var per_user_amount = $("#per_user_amount").val();
        var per_user_amount_money = $("#per_user_amount_money").val();
        var total_amount_money = $("#total_amount_money").html();
        $("#user_total").val(user_count);
        if (update !== 1) {
          $("#price").val(per_user_amount);
          $(".price").html(
            per_user_amount_money +
              "/month * " +
              user_count +
              " users = " +
              total_amount_money +
              "/Month"
          );
        } else {
          $(".per_user_amt").text($("#price").val());
          $("#total_amount_money").html($("#total_money").val());
        }
      }
    });
    $(".save_subscription_btn").addClass("hide");
  } else {
    $("body").LoadingOverlay("hide");
    if ($("#removeToAccountPlan").length) {
      $("[name=subscription]").val("account-level");
      $("#account-level").prop("checked", true);
      $("[name=subscription]").attr("disabled", true);
      $("#user_level_msg").html(
        "<strong>Firstly you have to unsubscribe Account-level Subscription after that you can subscribe User-level subscription.</strong>"
      );
    } else {
      $(".save_subscription_btn").removeClass("hide");
      $(".payment_div").addClass("hide");
      var valid_thru_date = $("#valid_thru_date").val();
      if (valid_thru_date)
        $("#response").html(
          "<strong>By making this change, each user on your account will have to set up their own subscription. They will need to do this before your account’s current paid-through date of " +
            valid_thru_date +
            " or they will lose access to the Evaluations module.</strong>"
        );
      else $("#response").html("");
    }
  }
}
function save_subscription() {
  var value = $(".change_subscription:checked").val();
  var accountId = $("#account_id").val();
  $.ajax({
    method: "POST",
    url: $("body").attr("data-base-url") + "accounts/change_subscription",
    data: { accountId: accountId, subscription: value },
  }).done(function (data) {
    if (data == "success") {
      saveToast();
    }
  });
}
function save_first_subscription() {
  var value = $(".save_first_subscription:checked").val();
  $.ajax({
    method: "POST",
    url: $("body").attr("data-base-url") + "accounts/save_first_subscription",
    data: { subscription: value },
    beforeSend: function () {
      $("body").LoadingOverlay("show", {
        image: $("body").attr("data-base-url") + "assets/img/loading.png",
        imageAnimation: "2500ms rotate_left",
        zIndex: 1000,
        background: "rgba(255, 255, 255, 0.95)",
      });
    },
  }).done(function (data) {
    if (data == "success") {
      $("#check_first_login").val("1");
      // Materialize.toast('Subscribed Successfully.');
      window.location =
        $("body").attr("data-base-url") +
        "billing/listing/" +
        $("#logged_id").val();
    } else {
      $("body").LoadingOverlay("hide");
    }
    $("#modal_first_login").modal("close");
  });
}

$(document).on("keyup", "#promo_code_check", function () {
  $("#promo_code_check_id").val("");
  $("#promoCodeDescription").html("");
  $("#checkPromoCode").html("Apply Promo Code");
});

function check_cap_comp_display() {
  var check_val = $(".select_comp_type:checked").val();
  var income_approach = $("#income_approach:checked").val();
  if (check_val == "land_only" || income_approach != "true") {
    $(".hide-if-land-income").addClass("hide");
  } else {
    $(".hide-if-land-income").removeClass("hide");
  }
}

function checkPromoCode() {
  var promo_code = $("#promo_code_check").val();
  if (promo_code !== "") {
    $.ajax({
      type: "POST",
      url: $("body").data("base-url") + "users/checkPromoCode",
      data: { promo_code: promo_code },
      success: function (responseText) {
        var response = JSON.parse(responseText);
        $("#promoCodeDescription").html("");
        if (response.status == "fail") {
          $("#promo_code_check").val("");
          $("#promoCodeDescription").html(response.msg);
          $("label[for='promo_code']").removeClass("active");
          $("#promo_code_check_id").val("");
        } else {
          $("#promo_code_check_id").val(response.coupon_id);
        }
      },
      failure: function (errMsg) {
        Materialize.toast("It was not possible to execute that action.", 2000);
      },
    });
  }
}

$(document).on("click", "#checkPromoCode", function () {
  var promo_code = $("#promo_code_check").val();
  if (promo_code !== "") {
    $.ajax({
      type: "POST",
      url: $("body").data("base-url") + "users/checkPromoCode",
      data: { promo_code: promo_code },
      beforeSend: function () {
        $("body").LoadingOverlay("show", {
          image: $("body").attr("data-base-url") + "assets/img/loading.png",
          imageAnimation: "2500ms rotate_left",
          zIndex: 1020,
          background: "rgba(255, 255, 255, 0.95)",
        });
      },
      success: function (responseText) {
        var response = JSON.parse(responseText);
        if (response.status == "fail") {
          $("#promo_code_check").val("");
          $("label[for='promo_code']").removeClass("active");
          $("#promo_code_check_id").val("");
          $("#checkPromoCode").html("Apply Promo Code");
        } else {
          $("#promo_code_check_id").val(response.coupon_id);
          $("#checkPromoCode").html("Applied Promo Code");
        }
        $("#promoCodeDescription").html(response.msg);
      },
      failure: function (errMsg) {
        Materialize.toast("It was not possible to execute that action.", 2000);
      },
    }).done(function () {
      $("body").LoadingOverlay("hide");
    });
  }
});
$(document).on("click", "#activate_subscription", function () {
  $("#subscription_plan").modal("open");
});

function maskCurrency(e, obj) {
  if (e.keyCode == 189) {
    $(obj).val("-$" + $(obj).val());
  }
  var sign = "";
  if ($(obj).val().indexOf("-") != -1) {
    sign = "-";
  }
  nStr = $(obj).val().replace(/[^\d]/g, "");
  if (nStr == "") {
    $(obj).val(sign);
    return;
  }

  nStr = !isNaN(parseFloat(nStr).toString())
    ? parseFloat(nStr).toString()
    : nStr;

  if (nStr.length == 1) {
    nStr = "0.0" + nStr;
  } else if (nStr.length == 2) {
    nStr = "0." + nStr;
  } else {
    var data = nStr;
    var place = ".";
    nStr = [data.slice(0, -2), place, data.slice(-2)].join("");
  }
  x = nStr.split(".");
  x1 = x[0];
  x2 = x.length > 1 ? ("." + x[1]).substr(0, 3) : ".00";
  var rgx = /(\d+)(\d{3})/;
  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, "$1" + "," + "$2");
  }
  var value = sign + "$" + x1 + x2;
  $(obj).val(value);
}

function handleChange(e, obj) {
  if (e.keyCode == 9) {
    return false;
  }
  if ($(obj).hasClass("postmask-percentage-current")) maskPercentage(e, obj);
  else maskCurrency(e, obj);
  ResEvaluationController.updateAdjustmentsFactors(obj);
}

function maskCurrencyLabel(val) {
  nStr = val || "0";
  x = nStr.split(".");
  x1 = x[0];
  x2 = x.length > 1 ? ("." + x[1]).substr(0, 3) : ".00";
  let rgx = /(\d+)(\d{3})/;
  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, "$1" + "," + "$2");
  }
  let value = "$" + x1 + x2;
  if (value.indexOf("-") != -1) {
    return value.replace("$-", "-$");
  } else {
    return value;
  }
}

function calculateAmenities(e, obj) {
  let total = 0;
  if ($(obj).hasClass("postmask-currency-current")) maskCurrency(e, obj);

  let parent = $(obj).parents(".comps");
  if ($(obj).hasClass("delete")) $(obj).parent().parent().remove();
  parent.find(".another_amenity_value").each(function () {
    let val = 0;
    if ($(this).val())
      val = $(this)
        .val()
        .replace(/[^\d.-]/g, "");
    total = parseFloat(parseFloat(total) + parseFloat(val)).toFixed(2);
  });
  parent.find("#amenities_total_input").val(total).keyup();
  let formattedTotal = parent.find("#amenities_total_input").val();
  parent.find("#amenities_total").html(formattedTotal);
}

function updateOtherAmenities(obj) {
  $(obj)
    .parents(".comps")
    .find("#add_amenities_adjustment_modal")
    .modal("close");
  let val = $(obj).parents(".comps").find("#amenities_total").html();
  $(obj)
    .parents(".comps")
    .find('[name="evaluation[sales_approach][comps][index][other_amenities]"]')
    .val(val)
    .keyup();
  if (val.replace(/[^\d.-]/g, "") == 0)
    $(obj)
      .parents(".comps")
      .find("span.amenities_adjustment_link")
      .html("Add Adjustment");
  else
    $(obj).parents(".comps").find("span.amenities_adjustment_link").html(val);

  ViewManager.save();
}

function addNewRow(obj) {
  let cloned_row = $(obj).parents(".comps").find(".add_another_amenity_row");
  let new_row = cloned_row.after(cloned_row.clone());
  new_row
    .removeClass("hide")
    .removeClass("add_another_amenity_row")
    .addClass("amenity_row");

  let order =
    $(obj)
      .parents(".comps")
      .find('[name="evaluation[sales_approach][comps][index][order]"]')
      .val() - 1;

  let subject_property_check_id =
    new_row.find(".subject_property_check").attr("id") + order;
  let length =
    $(obj).parents(".comps").find(".subject_property_check").length - 1;
  new_row
    .find(".subject_property_check")
    .attr("id", subject_property_check_id + length);

  new_row
    .find('label[for="subject_property_check"]')
    .attr("for", subject_property_check_id + length);

  let comp_property_check =
    new_row.find(".comp_property_check").attr("id") + order;
  new_row.find(".comp_property_check").attr("id", comp_property_check + length);

  new_row
    .find('label[for="comp_property_check"]')
    .attr("for", comp_property_check + length);
  let counter = length - 1;

  let another_amenity_name =
    "evaluation[sales_approach][comps][" +
    order +
    "][extra_amenity][c_index][another_amenity_name]";
  new_row
    .find(".another_amenity_name")
    .attr("name", getTagName(another_amenity_name, counter));

  let subject_property_check =
    "evaluation[sales_approach][comps][" +
    order +
    "][extra_amenity][c_index][subject_property_check]";
  new_row
    .find(".subject_property_check")
    .attr("name", getTagName(subject_property_check, counter));

  let comp_property_check_name =
    "evaluation[sales_approach][comps][" +
    order +
    "][extra_amenity][c_index][comp_property_check]";
  new_row
    .find(".comp_property_check")
    .attr("name", getTagName(comp_property_check_name, counter));

  let another_amenity_value =
    "evaluation[sales_approach][comps][" +
    order +
    "][extra_amenity][c_index][another_amenity_value]";
  new_row
    .find(".another_amenity_value")
    .attr("name", getTagName(another_amenity_value, counter));
}

function getTagName(name, counter) {
  return name.replace("c_index", counter);
}

function remove_row(e, obj) {
  calculateAmenities(e, obj);
}

function updateValue(obj) {
  if ($(obj).is(":checked")) {
    $(obj).val("1");
  } else {
    $(obj).val("0");
  }
}

function updateLabels(obj, approach) {
  const val = $(obj).val();
  const name = val
    .replace(/[^a-zA-Z0-9 ]/g, "")
    .replace(/ /g, "_")
    .toLowerCase();
  $(obj).attr(
    "name",
    "evaluation[" + approach + "][subject_property_adjustments][" + name + "]"
  );
  $(obj).attr("data-name", name);
  updateLabelsClass();
  updateCompsInputs();
}

function updateLabelsClass() {
  let counter = 1;
  $(".label-value").each(function () {
    let old_counter = removeClass(this, "counter-label-");
    $(this)
      .removeClass(old_counter)
      .addClass("counter-label-" + counter);
    $(this)
      .closest(".adjustmentlabel")
      .find(".add-label")
      .attr("value", counter);
    $(this)
      .closest(".adjustmentlabel")
      .find(".delete-label")
      .attr("value", counter);
    counter++;
  });
}

function removeClass(obj, check_class) {
  let all_classes = $(obj).attr("class");
  let old_class = "";
  if (all_classes) {
    all_classes = all_classes.split(" ");
    all_classes.forEach(function (entry) {
      if (entry.includes(check_class)) {
        old_class = entry;
      }
    });
  }
  return old_class;
}

function updateCompsInputs() {
  if (location.pathname.indexOf("/sales") !== -1) {
    apprach_name = "sales_approach";
  } else if (location.pathname.indexOf("/leaseComps") !== -1) {
    apprach_name = "lease_comps";
  } else if (location.pathname.indexOf("/cost") !== -1) {
    apprach_name = "cost_approach";
  } else if (location.pathname.indexOf("/multiFamilyComps") !== -1) {
    apprach_name = "multi_family_approach";
  }
  $(".comp-entry").each(function () {
    let counter = 1;
    let child = $(this).find(".selector");
    $(child).each(function () {
      if (
        !$(this).children().children().hasClass("percentage-dropdown-weighting")
      ) {
        let old_counter = removeClass(this, "counter-");
        $(this)
          .removeClass(old_counter)
          .addClass("counter-" + counter);
        const name = $(".counter-label-" + counter).attr("data-name");
        if ($("#comp_adjustment_mode").val() == "Dollar") {
          $(this)
            .find("input.select-dollar")
            .attr(
              "name",
              "evaluation[" + apprach_name + "][comps][index][" + name + "]"
            )
            .attr(
              "id",
              "evaluation[" + apprach_name + "][comps][index][" + name + "]"
            );
        } else {
          $(this)
            .find("select")
            .attr(
              "name",
              "evaluation[" + apprach_name + "][comps][index][" + name + "]"
            )
            .attr("data", "")
            .attr("data", name + "_custom");
          let old_custom = removeClass(
            $(this).find("input.custom_field"),
            "_custom"
          );
          $(this)
            .find("input.custom_field")
            .attr(
              "name",
              "evaluation[" +
                apprach_name +
                "][comps][index][" +
                name +
                "_custom]"
            )
            .removeClass(old_custom)
            .addClass(name + "_custom");
        }
        counter++;
      }
    });
  });
}

function change_the_property(obj, id) {
  let data_attr = $(obj).find("select").attr("data-attr");
  let input_val = $(obj).find("input").val();
  if (data_attr == input_val) {
    $(".update-property" + id).val("false");
  } else {
    $(".update-property" + id).val("true");
  }
}

function change_subtype(obj) {
  let checkScreen = "";
  if (location.pathname.indexOf("evaluations/") !== -1) {
    checkScreen =
      $("#comparison_basis").val() == "Unit" &&
      ApproachCalculator.checkPropertyType() &&
      $("#eval_multi_family").prop("checked") == true;
  } else {
    checkScreen =
      $("#comparison_basis").val() == "Unit" &&
      ApproachCalculator.checkPropertyType();
  }
  if (checkScreen) {
    $(".unit-section").removeClass("hide");
    ApproachCalculator.check_unit_val = ApproachCalculator.calculateUnits();
  } else {
    $(".unit-section").addClass("hide");
  }
  $(obj)
    .closest(".property-type-row")
    .find(".subzone_type_custom")
    .closest(".subzone-type-option")
    .addClass("enable-type-own");
  $(obj).closest(".property-type-row").find(".subzone_type_custom").val("");
}

function impersonation(user_data) {
  impersonateConfirm(function () {
    let data = user_data;
    $.ajax({
      type: "POST",
      url: $("body").attr("data-base-url") + "users/impersonate",
      data: { impersonate: data },
      success: function (responseTxt) {
        var response = JSON.parse(responseTxt);
        if (response.status == "success") {
          Materialize.toast(response.msg, 3000, "blue");
        } else {
          Materialize.toast(response.msg, 3000, "red");
        }
      },
    }).done(function () {
      location.reload();
    });
  });
}
